import { c as _c } from "react/compiler-runtime";
import { BodyShort, Box, Heading, Label, Stack, VStack } from "@navikt/ds-react";
import { useBehovContextState } from "@/app/(behov)/[behovId]/state/contextState";
import { UiSelector } from "@/utils/uiSelectors";
export default function SykmeldtBox() {
  const $ = _c(11);
  const {
    lederInfo
  } = useBehovContextState();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Heading level="2" className="mt-2" size="medium">Sykmeldt</Heading>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: "space-12",
      sm: "space-32",
      md: "space-64",
      lg: "space-128"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Label size="medium" className="min-w-32">Navn</Label>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== lederInfo.sykmeldt.fullnavn) {
    t3 = <Stack direction="column" gap="space-16">{t2}<BodyShort className="min-w-32">{lederInfo.sykmeldt.fullnavn}</BodyShort></Stack>;
    $[3] = lederInfo.sykmeldt.fullnavn;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Label size="medium" className="min-w-32">Fødselsnummer</Label>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== lederInfo.sykmeldtFnr) {
    t5 = <Stack direction="column" gap="space-16">{t4}<BodyShort className="min-w-32">{lederInfo.sykmeldtFnr}</BodyShort></Stack>;
    $[6] = lederInfo.sykmeldtFnr;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <Box padding="space-16" background="accent-soft" borderRadius="8" data-testid={UiSelector.SykmeldtBox}><VStack gap="space-24">{t0}<Stack direction="row" gap={t1}>{t3}{t5}</Stack></VStack></Box>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}